<div class="login-container" fxLayout="column" style="margin: 0 auto;">
  <div class="usmc-logo"></div>

  <h1 style="text-align: center;">FitForce Planner</h1>

  <form #loginForm="ngForm" fxLayout="column">
    <div *ngIf="errorMsg" class="error-msg">{{errorMsg}}</div>

    <mat-form-field style="width: 100%;">
      <input type="email" matInput placeholder="email" name="email" required #emailField="ngModel"
             [(ngModel)]="emailAddress">
      <mat-error
        *ngIf="emailField.errors && (emailField.dirty || emailField.touched) && emailField.errors.required">
        Email is <strong>required</strong>.
      </mat-error>
    </mat-form-field>

    <mat-form-field style="margin-top: 20px; width: 100%;">
      <input type="password" matInput placeholder="password" name="password" required #passwordField="ngModel"
             [(ngModel)]="password">
      <mat-error
        *ngIf="passwordField.errors && (passwordField.dirty || passwordField.touched) && passwordField.errors.required">
        Password is <strong>required</strong>.
      </mat-error>
    </mat-form-field>

    <div fxLayout="row" fxLayoutAlign="center">
      <button mat-raised-button color="primary" type="submit" (click)="login(emailAddress, password)" [disabled]="!loginForm.form.valid || inProgress">
        Log In
      </button>
    </div>

    <div class="login-progress" [ngClass]="{'login-progress--hidden': !inProgress}">
      <mat-spinner></mat-spinner>
    </div>
  </form>

  <div fxLayout="column" class="footer-links" fx-layout-gap="8px">
    <div fxLayout="row" fxLayoutAlign="center center">
      <a href="{{getLink('create_account_url')}}">
        Create New Account</a>
      <span fxFlex="5">|</span>
      <a href="{{getLink('reset_password_url')}}">Forgot Password?</a>
      <span fxFlex="5">|</span>
      <a href="{{supportUrl}}" rel="noopener noreferrer" target="_blank">Support</a>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <a [href]="tou_url">Terms of Use</a>
      <span fxFlex="5">|</span>
      <a [href]="pp_url">Privacy Policy</a>
    </div>
    <a style="font-size: 1rem; font-weight: bold;" href="{{getMobileLink()}}">FitForce Mobile</a>
  </div>
</div>

<div fxLayout="column" fxLayoutGap="24px">
  <div fxFlex fxLayout="row" class="empty-space">
  </div>
  <div fxFlexFill fxLayout="row" fxLayoutAlign="center center">
    <dod-notice-and-consent-banner></dod-notice-and-consent-banner>
  </div>  
</div>
